// Les factures de commission arrivent du back en CENTIMES : tout affichage
// passe obligatoirement par formatCents pour éviter un facteur 100.
export const formatCents = (cents, locale = "fr-FR", currency = "eur") => {
  if (cents === null || cents === undefined || isNaN(cents)) return "-";

  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: (currency || "eur").toUpperCase(),
  }).format(cents / 100);
};

export const formatInvoicePeriod = (periodMonth, periodYear, locale = "fr-FR") => {
  if (!periodMonth || !periodYear) return "-";

  // periodMonth est 1-12, le constructeur Date attend 0-11.
  const date = new Date(periodYear, periodMonth - 1, 1);
  const label = date.toLocaleDateString(locale, {
    month: "long",
    year: "numeric",
  });

  return label.charAt(0).toUpperCase() + label.slice(1);
};

// i18next donne "fr" / "en", Intl veut une locale complète.
export const localeFromLanguage = (language) =>
  language && language.startsWith("en") ? "en-GB" : "fr-FR";
